import React, { Component } from 'react'
import YouTubePlayer from 'youtube-player'
import View from './view'

export default class extends Component {
	constructor(props) {
		super(props)

		this.player = null


	}

	componentDidMount() {
		this.player = YouTubePlayer('video-player', {
			playerVars: {
				autoplay: 1,
				controls: 0,
				disablekb: 1,
				fs: 0,
				modestbranding: 1,
				playsinline: 1,
				rel: 0,
				showinfo: 0,
			},
		})

		//this.player.loadVideoById('BmX9kwHKLyg')
		this.player.loadVideoById(this.props.id)

		this.player.on('stateChange', (event) => {
		    // event.data
		})
	}

	render() {
		return (
			<View {...this.props} />
		)
	}
}



// WEBPACK FOOTER //
// ./src/desktop/components/video-player/index.js